module.exports = "/_next/static/images/82714e95910973617629bae767c4135a-woman-with-iphone@0.75x.jpg";